import React from "react"
import { useDispatch } from "react-redux"
import { Card, CardBody, Col, Row, Table } from "reactstrap"
import { removePosDataByName } from "../../reducers/posAnalyticsSlice"

const PosDataTrackTable = ({ serie }) => {
    let dispatch = useDispatch()

    const getAlertClassName = (score) => {
        let className = "text-center alert "

        if(score >= 0 && score <= 1) className += "alert-purple"
        else if(score > 1 && score <= 2) className += "alert-danger"
        else if(score > 2 && score <= 3) className += "alert-warning"
        else className += "alert-success"
        
        return className
    }

    const removeSerie = () => {
        let ids = []
        serie.data.forEach(datum => {
            ids.push(datum.id)
        })
        dispatch(removePosDataByName({ids: ids}))
    }

    return <Card>
        <CardBody>
            <Row>
                <Col md="11"><h2 style={{paddingLeft: "1.25rem", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{serie.name}</h2></Col>
                <Col md="1" className="text-right">
                    <span 
                        className="mdi mdi-close" 
                        style={{fontSize: '25px', position: 'relative', right: '5px', bottom: '5px', cursor: 'pointer', float: 'right'}} 
                        onClick={removeSerie}
                    ></span>
                </Col>
            </Row>
            <div style={{height: '350px', overflow: 'auto'}}>
                <Table responsive hover >
                    <thead>
                        <tr>
                            <th style={{width: '99%'}}>Data</th>
                            <th style={{width: '1%'}} className="text-center">Punteggio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serie.data.map((datum) => (
                            <tr key={datum.id}>
                                <td>{datum.key}</td>
                                <td>
                                    <div className={getAlertClassName(datum.value)} style={{marginBottom: 0}}>{parseFloat(datum.value.toFixed(2))}</div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </CardBody>
    </Card>
}

export default PosDataTrackTable;